import React from 'react';

const SearchIcon = () => {
  return (
    <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
      <path data-name="Path 26669" d="m27.056 25.127-4.618-4.6a10.758 10.758 0 0 0 2.3-6.656 10.867 10.867 0 1 0-10.871 10.862 10.758 10.758 0 0 0 6.656-2.3l4.6 4.618a1.364 1.364 0 1 0 1.929-1.929zM5.717 13.867a8.15 8.15 0 1 1 8.15 8.15 8.15 8.15 0 0 1-8.15-8.15z"
        transform="translate(.628 1.075)" fill={'currentColor'}/>
    </svg>
  );
};

export default SearchIcon;
